import Consts from './ConstantesGlobais'
import SPMapaNomes from './SPMapaNomes'

export default {
  avaliar,
  abreviarOrgaos,
  abreviarCargos,
  calculaPontosCentrais,
  createEncodeQuery,
  dataParaMesExtensoAno,
  dateToJsonDateParts,
  decodificarToken,
  findLineByLeastSquares,
  idSvgToNumeric,
  logarErro,
  mapeiaMesAbreviacao,
  montarToken,
  numericToIdSvg,
  ordenaTabela,
  ordenaTabelaParseFloat,
  ordenaTabelaParseInt,
  ordenaTabelaDiasDaSemana,
  ordenaTabelaData,
  percentualLabelCallback,
  regressaoLinearMinimosQuadrados,
  thousandSeparator,
  validaPermissaoFullScreen,
  validaRangeEixo,
  gerarMensagemErroBackend,
  arredondaPorcentagens,
  formataPercentual,
  formataNumeroInteiro,
  formataNumeroDecimal,
  sortAsc,
  sortDesc,
  formatarTexto,
  formatarNumero,
  isEmpty,
  formatarGrandesNumeros,
  _getPercentile,
  formataStringCallback,
  check,
  range,
  multipleGroupAndSum,
  flatArrayToLineChartDatasets,
  rodapeData,
  decimalConverter,
  filterByNumber,
  filterByRange,
  filterByString,
  filtraTermoBusca,
  isNullOrUndefined,
  replaceSpecialChars,
  isTextoVazio,
  isObject,
  formataDataHora,
  formataDataParaStringDataLocal
}

/**
*  Função para avaliar um valor (resultadoExpressao) e tentar mapear
*  usando o filtro padrão ou customizado, o resultado com alguma chave do
*  objeto de mapeamento (mapeamento) e retornar o valor correspondente da
*  chave ou um valor de fallback.
*  @param resultadoExpressao
*  @param {JSON} mapeamento
*  @param fallback
*  @param customFiltroMapeamento
*  @returns valor
*/
function avaliar (resultadoExpressao, mapeamento, fallback = 'N/A', customFiltroMapeamento = null) {
  let estrategia = null
  if (!customFiltroMapeamento) {
    estrategia = function (resultadoExpressao) {
      return function (k) {
        return k === resultadoExpressao
      }
    }
  } else {
    estrategia =
          function (resultadoExpressao) {
            return function (k) {
              return customFiltroMapeamento(k, resultadoExpressao)
            }
          }
  }
  let mapa = Object.keys(mapeamento).filter(estrategia(resultadoExpressao)).map(k => mapeamento[k])
  return mapa.length ? mapa[0] : fallback
}

function rodapeData (d = 0, data = new Date()) {
  if (d) {
    return data.toLocaleDateString('pt-BR')
  } else {
    data.setDate(data.getDate() + d)
    return data.toLocaleDateString('pt-BR')
  }
}

function _getPercentile (data, percentile, atr) {
  let index = (percentile / 100) * data.length
  let result
  if (Math.floor(index) === index) {
    if (atr) {
      result = (data[(index - 1)][atr] + data[index][atr]) / 2
    } else {
      result = (data[(index - 1)] + data[index]) / 2
    }
  } else {
    result = data[Math.floor(index)]
  }
  return result
}

function calculaPontosCentrais (arr, atr) {
  let points = {
    domain: [],
    uniqDomain: [],
    median: 0,
    // mode: 0,
    mean: 0,
    max: 0,
    min: 0,
    std: 0,
    q1: 0,
    q3: 0,
    percentile: 0,
  }

  let nums = [...arr].sort((a, b) => a[atr] - b[atr])
  points.percentile = _getPercentile(nums, 1, atr)
  points.q1 = _getPercentile(nums, 25, atr)
  points.median = _getPercentile(nums, 50, atr)
  points.q3 = _getPercentile(nums, 75, atr)
  points.min = _.min(arr) || _.first(nums)
  points.max = _.max(arr) || _.last(nums)
  points.mean = _.mean(arr)
  points.std = Math.sqrt(arr.map(x => Math.pow(x - points.mean, 2)).reduce((a, b) => a + b) / arr.length)
  points.domain = nums
  points.uniqDomain = (_.uniq(nums)).sort(function (a, b) { return a - b })

  return points
}

function replaceSpecialChars (str) {
  str = str.replace(/[ÀÁÂÃÄÅ]/, 'A')
  str = str.replace(/[àáâãäå]/, 'a')
  str = str.replace(/[ÈÉÊË]/, 'E')
  str = str.replace(/[èéêë]/, 'e')
  str = str.replace(/[ÌÍÎÏ]/, 'I')
  str = str.replace(/[ìíîï]/, 'i')
  str = str.replace(/[ÒÓÕÔÖ]/, 'O')
  str = str.replace(/[òóôõö]/, 'o')
  str = str.replace(/[ÙÚÜ]/, 'U')
  str = str.replace(/[ùúü]/, 'u')
  str = str.replace(/[Ç]/, 'C')
  str = str.replace(/[ç]/, 'c')
  return str
}

/**
 * Function para criar query de parâmetros e fazer seu encoding. ex.
 *
 * params (Json):
 * {
 *    'nome':'Sérgio Malandro',
 *    'brincadeira':'Casa, Beija ou Salci Fufu'
 * }
 *
 * return (String):
 * nome=S%C3%A9rgio%20Malandro&brincadeira=Casa%2C%20Beija%20ou%20Salci%20Fufu
 *
 * @param {JSON} params
 * @returns String
 */
function createEncodeQuery (params) {
  let esc = encodeURIComponent

  let query = Object.keys(params).filter((k) => {
    if (params[k]) { return true }
    return false
  })
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&')

  return (query ? `?${query}` : query)
}

function decodificarToken (token) {
  var jwtDecode = require('jwt-decode')
  return jwtDecode(token)
}

/**
 * Recebe um Date (ISO 8601) ou uma string de data e
 * retorna um json com a o dia, mês e ano separados.
 *
 * Exemplos de datas de entrada de string:
 *
 *  03-02-1999 6/08/2019 29-1-2020 5-4-2007 4 3 2008 28_2_1995 6.5.2014 20190812 ...
 *
 *  ou também o inverso:
 *
 *  2019-07-04 1992/3/2 2019.02.02 01061993 ...
 *
 * Exemplo do formato de retorno:
 *
 * {
 *    dia: 1,
 *    mes: 1,
 *    ano 1900
 * }
 *
 * Caso o valor passado seja inválido, será retornado false.
 * @param {*} date
 * @returns {JSON}
 */
function dateToJsonDateParts (date) {
  let dateVerificada = null
  if (date) {
    if (typeof date === 'string') {
      if (date.length === 8 && !isNaN(+date)) {
        /* Valida datas do tipo 03022019 20191108 01011998
                    tipo1: 03022019
                    tipo2: 20190302
                */
        const tipo1 = /^([1-2][0-9]|(3)[0-1]|(0)[1-9])(((1)[0-2])|(0)[1-9]|(1)[1-2])\d{4}$/
        const tipo2 = /^\d{4}(((1)[0-2])|(0)[1-9]|(1)[1-2])([1-2][0-9]|(3)[0-1]|(0)[1-9])$/
        if (tipo1.test(date)) { dateVerificada = (`${date.substring(4, 8)}-${date.substring(2, 4)}-${date.substring(0, 2)}`) } else if (tipo2.test(date)) { dateVerificada = (`${date.substring(0, 4)}-${date.substring(4, 6)}-${date.substring(6, 8)}`) } else { return false }
      } else if (date.length >= 8 && date.length < 11) {
        const tipo3 = /^(\d{4}[/\-\_ \.]{1}(((0){0,1}[1-9]|(1)[1-2])|((1)[0-2]))[/\-\_ \.]{1}([1-2][0-9]|(3)[0-1]|(0){0,1}[1-9]))$/
        const tipo4 = /^(((0){0,1}[1-9]|[1-2][0-9]|(3)[0-1])[/\-\_ \.]{1}(((0){0,1}[1-9]|(1)[1-2])|((1)[0-2]))[/\-\_ \.]{1}\d{4})$/
        if (tipo3.test(date)) {
          let part = date.split(/[/\-\_ \.]/)
          dateVerificada = (`${part[0]}-${part[1]}-${part[2]}`)
        } else if (tipo4.test(date)) {
          let part = date.split(/[/\-\_ \.]/)
          dateVerificada = (`${part[2]}-${part[1]}-${part[0]}`)
        } else { return false }
      } else {
        date = new Date(date)
      }
    }
    if (Object.prototype.toString.call(date) === '[object Date]') {
      if (isNaN(date.getTime())) {
        return false
      } else {
        dateVerificada = (`${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`)
      }
    }
    if (!dateVerificada) { return false }

    let dataCorrecoes = new Date(dateVerificada)

    return { dia: dataCorrecoes.getUTCDate(), mes: dataCorrecoes.getUTCMonth() + 1, ano: dataCorrecoes.getUTCFullYear() }
  }
  return false
}

/**
 * https://dracoblue.net/dev/linear-least-squares-in-javascript/
 * Metodo para regressao linear no metodo de minimos quadrados
 * @param {Array} values_x Valores do eixo X Numbers
 * @param {Array} values_y Valores do eixo Y Numbers
 * @return {Array}
 */
function findLineByLeastSquares (values_x, values_y) {
  // Verifica Se os vetores são maiores que zero e possuem o mesmo tamanho.
  if (values_x.length !== values_y.length) {
    throw new Error('The parameters values_x and values_y need to have same size!')
  } else if (values_x.length === 0) {
    return [ [], [] ]
  }
  let sumx = 0
  let sumy = 0
  let sumxy = 0
  let sumxx = 0
  let resultvaluesx = []
  let resultvaluesy = []
  /*
   * Calculate the sum for each of the parts necessary.
   */
  for (let v = 0; v < values_x.length; v++) {
    let x = values_x[v]
    let y = values_y[v]
    sumx += x
    sumy += y
    sumxx += x * x
    sumxy += x * y
  }

  /*
   * Calculate m and b for the formular:
   * y = x * m + b
   */
  let m = (values_x.length * sumxy - sumx * sumy) / (values_x.length * sumxx - sumx * sumx)
  let b = (sumy / values_x.length) - (m * sumx) / values_x.length

  /*
   * We will make the x and y result line now
   */
  for (let v = 0; v < values_x.length; v++) {
    let x = values_x[v]
    let y = x * m + b

    resultvaluesx.push(x)
    resultvaluesy.push(y)
  }
  return [resultvaluesx, resultvaluesy] // [0:[X], 1:[Y] ]
}

function validaPermissaoFullScreen (user) {
  if (typeof user.perfis === 'undefined') return false
  return user.perfis.indexOf(Consts.PERFIL_PREFEITOP) >= 0
}

// Redundante--- logMixin
function logarErro (mensagemErro, tipo = 'info', textoToast, tipoToast = Consts.TOASTED_ERROR) {
  console[tipo](`Erro: ${mensagemErro}`)
}

function idSvgToNumeric (id) {
  let idNum = id.replace(/\D/g, '')
  idNum = parseInt(idNum, 10)
  return idNum
}

/**
 * Caso seja passado um numeral correspondente a algum mês,
 * retorna-se um objeto contendo o nome do mês e sua abreviação.
 * Caso seja inválido ou nulo, uma array com todos os meses será
 * retornada.
 *
 * @param {Integer} mes
 * @returns {JSON}
 */
function mapeiaMesAbreviacao (mes) {
  var meses = [ { nome: 'Janeiro', abrev: 'Jan' },
    { nome: 'Fevereiro', abrev: 'Fev' },
    { nome: 'Março', abrev: 'Mar' },
    { nome: 'Abril', abrev: 'Abr' },
    { nome: 'Maio', abrev: 'Maio' },
    { nome: 'Junho', abrev: 'Jun' },
    { nome: 'Julho', abrev: 'Jul' },
    { nome: 'Agosto', abrev: 'Ago' },
    { nome: 'Setembro', abrev: 'Set' },
    { nome: 'Outubro', abrev: 'Out' },
    { nome: 'Novembro', abrev: 'Nov' },
    { nome: 'Dezembro', abrev: 'Dez' },
  ]

  if (mes && Number.isInteger(mes) && mes > 0 && mes <= 12) {
    return meses[mes - 1]
  } else {
    return meses
  }
}

function dataParaMesExtensoAno (data) {
  let jsonData = dateToJsonDateParts(data)
  let mesExtenso = mapeiaMesAbreviacao(jsonData.mes)
  return `${mesExtenso.abrev}/${jsonData.ano}`
}

function montarToken (token) {
  return `Bearer ${token}`
}

function numericToIdSvg (id) {
  let idSvg = 'sub' + id
  return idSvg
}

function ordenaTabela (item1, item2) {
  return item1 >= item2 ? 1 : -1
}

function ordenaTabelaParseInt (item1, item2) {
  item1 = parseInt(item1)
  item2 = parseInt(item2)
  return ordenaTabela(item1, item2)
}

function ordenaTabelaParseFloat (item1, item2) {
  item1 = parseFloat(item1)
  item2 = parseFloat(item2)
  return ordenaTabela(item1, item2)
}

function ordenaTabelaDiasDaSemana (item1, item2) {
  const sorter = {
    'domingo': 0,
    'segunda-feira': 1,
    'terça-feira': 2,
    'quarta-feira': 3,
    'quinta-feira': 4,
    'sexta-feira': 5,
    'sábado': 6,
  }
  let a = item1.toLowerCase()
  let b = item2.toLowerCase()
  return sorter[a] >= sorter[b] ? 1 : -1
}

function ordenaTabelaData (item1, item2) {
  let a = new Date(item1)
  let b = new Date(item2)
  return a >= b ? 1 : -1
}

function sortAsc (items, field) {
  return _.orderBy(items, [field], ['asc'])
}

function sortDesc (items, field) {
  return _.orderBy(items, [field], ['desc'])
}

/**
 * Cria o callback com algumas parametrizações dos valores (percentual, prefixo e separador de milhar).
 * Passa-se se irá usar o percentual, se irá usar o separador de milhar e um prefixo definido.
 * @param {Boolean} perc
 * @param {Boolean} separadorMilhar
 * @param {String} type
 * @param {String} prefixo
 * @param {Object} converterSeparadorDecimal  Objeto com a chave "de" com o separador decimal
 * atual tipo string e a chave "para" com o separador de decimal requerido. Ex. {de: '.', para: ','}
 */
function percentualLabelCallback (perc, separadorMilhar, type, prefixo = null, converterSeparadorDecimal = { de: '.', para: ',' }) {
  if (type === 'pie' || type === 'donut' || type == 'line') {
    return {
      label: function (tooltipItem, data) {
        let dataLabel = type === 'line' ? data.datasets[tooltipItem.datasetIndex].label : data.labels[tooltipItem.index]
        let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        value = value.toString()
        value = value.replace(converterSeparadorDecimal.de, converterSeparadorDecimal.para)
        value = (separadorMilhar ? thousandSeparator(value, '.', ',') : value) + (perc ? '%' : '')
        return dataLabel + ': ' + (prefixo ? prefixo + ' ' : '') + value
      },
    }
  } else {
    return {
      label: function (tooltipItem, data) {
        let label = data.datasets[tooltipItem.datasetIndex].label + ': ' || ''
        let num = type == 'horizontal-bar'
          ? tooltipItem.xLabel.toString().replace(converterSeparadorDecimal.de, converterSeparadorDecimal.para)
          : tooltipItem.yLabel.toString().replace(converterSeparadorDecimal.de, converterSeparadorDecimal.para)
        if (separadorMilhar) { label += thousandSeparator(num, '.', ',') }
        if (label && perc) { label += '%' }
        return (prefixo ? prefixo + ' ' : '') + label
      },
    }
  }
}

function regressaoLinearMinimosQuadrados (arr, atrX, atrY) {
  let eixoX = []
  let eixoY = []

  arr.forEach(e => {
    if (e.hasOwnProperty(atrX) && e.hasOwnProperty(atrY)) {
      eixoX.push(e[atrX])
      eixoY.push(e[atrY])
    }
  })

  let result = findLineByLeastSquares(eixoX, eixoY)
  let cordenadas = []
  for (let index = 0; index < result.resultvaluesx.length; index++) {
    cordenadas.push({ x: result.resultvaluesx[index], y: result.resultvaluesx[index] })
  }

  return cordenadas
}

/**
 *  Recebe um NUMERO e adiciona um separador a cada unidade de milhar.
 * @param {Number} x  // Numero a ser separado
 * @param {String} separator // Separador - Padrão '.'
 * @param {String} decimal // separador de casas decimais para considerar, caso haja, senão null
 * @returns {String}
 */
function thousandSeparator (x, separator = '.', decimal = null) {
  let validacao = x
  if (typeof validacao === 'string') {
    validacao = validacao.replace(decimal || ',', '.')
  }
  if (!isNaN(validacao)) {
    if (decimal) {
      let parts = x.toString().split(decimal)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator)
      return parts.join(decimal)
    } else {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
    }
  } else {
    console.error('MetodosGlobais.thousandSeparator recebeu NULL/Undefined/Falsey ou número inválido ' + x)
    return null
  }
}

/**
 *  Recebe um erro do backend do SP360 e formata em uma mensagem
 * @param {Object} error // Erro para tratar
 * @returns {String}
 */
function gerarMensagemErroBackend (error) {
  if (error) {
    let codigo = error.data.codigo
    let mensagem = error.data.mensagem
    return `Erro de código ${codigo}. ${mensagem}`
  } else {
    return 'Erro genérico não identificado.'
  }
}

/**
  *   Passa uma array de range N, ex.: [0, 10] ou [0, 15, 0, 25]
  *   e faz a validação para possibilidade de se usar em eixos.
  *   A Array de range pode ter valor N, e a validação sempre
  *   levará em conta que o valor anterior precisa ser menor
  *   que o próximo valor.
  *
  *   Caso não seja validado, pode-se passar um valor padrão:
  *   rangePerc de fallback, por padrão [0, 25].
  *
  *   Retorna uma array de ranges validados
  *
  *  @param {Array} arrayRange
  *  @param {Array} rangePerc
  *  @returns {Array}
*/
function validaRangeEixo (arrayRange, rangePerc = [0, 25]) {
  if (arrayRange && Array.isArray(arrayRange) && arrayRange.length > 0 && (arrayRange.length % 2) === 0) {
    for (let i = 0; i < arrayRange.length; i += 2) {
      if (arrayRange[i] >= arrayRange[i + 1]) { return rangePerc }
    }
  } else {
    return rangePerc
  }
  return arrayRange
}

/**
  *   Faz arredondamento básico das porcentagens. Para aceitar
  *   o arredondamento, os valores floats somados precisam ter menos
  *   de 0,4 de diferença do 100. Ex.:
  *   13,5894305834 + 29,0942340923 + 57,3163353241 = 99,9999999999 OK
  *   33,111 + 32,111 + 34,333 = 99,555 NOK
  *
  *
  *   Retorna uma array de ranges validados. Quando o valor ultrapassar
  *   100, subtrai-se do maior, caso contrário, soma-se ao maior.
  *
  *  @param {Array} arrayValores
  *  @param {Array} casasDecimais
  *  @returns {Array} valores arredondados na mesma ordem na array.
*/
function arredondaPorcentagens (arrayValores, casasDecimais) {
  if (arrayValores.length > 0) {
    if (parseInt(arrayValores.reduce((a, b) => a + b, 0).toFixed(0)) != 100) return null
    let maiorValor = { val: 0, idx: 0 } /* Otimização */
    let somatorio = 0 /* Otimização */
    for (let i = 0; i < arrayValores.length; i++) {
      if (arrayValores[i] > maiorValor.val) {
        maiorValor.val = arrayValores[i]
        maiorValor.idx = i
      }
      arrayValores[i] = parseFloat(arrayValores[i].toFixed(casasDecimais))
      somatorio += arrayValores[i]
    }
    if (somatorio > 100) {
      arrayValores[maiorValor.idx] -= 100 - somatorio
    } else if (somatorio < 100) {
      arrayValores[maiorValor.idx] += 100 - somatorio
    }
    return arrayValores
  }
  return null
}

/**
 * Função para conversão do separador decimal
 * tanto de string quanto de float
 *
 * @param {String | Number} numero Valor que será convertido o separador decimal
 * @param {String} from Separador decimal inicial do valor passado
 * @param {String} to Separador decimal no qual será convertido o separador inicial
 */
function decimalConverter (numero, from = '.', to = ',') {
  if (typeof numero === 'number') {
    return numero.toString().replace(from, to)
  } else if (typeof numero === 'string') {
    return numero.replace(from, to)
  }
  console.error('MetodosGlobais.formatarNumero recebeu valor diferente de number ou string ' + numero)
  return null
}

/**
 * Função para auxiliar na formatação dos números do projeto
 * @param {String | Number} numero Valor que será formatado
 * @param {Number} casasDecimais Número de casas decimais usadas 0..N
 * @param {String} prefixo Valor de prefixo acompanhado ao número. Ex. R$
 * @param {String} posfixo Valor de prefixo acompanhado ao número. Ex. %
 * @param {Boolean} separadorMilhar Usar ou não o separador de milhar.
 */
function formatarNumero (numero, casasDecimais = 2, prefixo = '', posfixo = '', separadorMilhar = true) {
  let valorFormatado = ''
  let tipo1 = /(?:^[0-9\,]+\.\d+$)/ // Sabe que é um número com casa decimal com ponto
  let tipo2 = /(?:^[0-9\.]+\,\d+$)/ // Sabe que é um número com casa decimal com vírgula

  if (typeof numero === 'number') {
    valorFormatado = numero.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: casasDecimais })
  } else if (typeof numero === 'string') {
    if (tipo1.test(numero)) {
      valorFormatado = parseFloat(numero.replace(/\,/gi, ''))
    } else if (tipo2.test(numero)) {
      valorFormatado = parseFloat(numero.replace(/\./gi, '').replace(',', '.'))
    } else {
      /* Número inteiro */
      valorFormatado = parseInt(numero.replace(/\,/gi, '').replace(/\./gi, ''))
    }
    valorFormatado = valorFormatado.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: casasDecimais })
  } else {
    console.error('MetodosGlobais.formatarNumero recebeu valor diferente de number ou string ' + numero)
    return null
  }
  if (!separadorMilhar) valorFormatado = valorFormatado.replace(/\./gi, '')
  return (prefixo + valorFormatado + posfixo)
}

/**
 *
 * @param {String | Number} numero Valor que será formatado
 * @returns {String} Retorna uma porcentagem com duas casas decimais usando padrão brasileiro Ex. 14,92%
 */
function formataPercentual (numero) {
  return formatarNumero(numero, 2, '', '%')
}

/**
 *
 * @param {String | Number} numero Valor que será formatado
 * @returns {String} Retorna um número inteiro com separador de milhar Ex. 1.549
 */
function formataNumeroInteiro (numero) {
  return formatarNumero(numero, 0)
}

/**
 *
 * @param {String | Number} numero Valor que será formatado
 * @returns {String} Retorna um número decimal com separador de milhar Ex. 1.549,33 ou 944,18
 */
function formataNumeroDecimal (numero) {
  return formatarNumero(numero, 2)
}

/**
 * Função para formatar uma string com parâmetros, ex.
 *
 * texto:
 * "Hoje o {%nome%} vai te ensinar a brincar de {%brincadeira%}."
 *
 * parametros
 * {
 *   "brincadeira": "Casa, Beija ou Salci Fufu",
 *   "nome": "Sérgio Malandro"
 * }
 * Retorno:
 * "Hoje o Sérgio Malandro vai te ensinar a brincar de Casa, Beija ou Salci Fufu."
 *
 * Caso seja uma array, os parâmetros serão colocados seguindo a ordem da array e ignorando as identificações.
 * Caso não haja um correspondente no texto de template, o mesmo não será substituído.
 *
 * @param {String} texto Texto de template no qual serão colocados os parâmetros
 * @param {Object | Array} parametros Parâmetros
 * @returns {String} Texto formatado
 */
function formatarTexto (texto, parametros) {
  function _safeToString (x) {
    switch (typeof x) {
      case 'object':
        return 'object'
      case 'function':
        return 'function'
      case 'undefined':
        return 'undefined'
      default:
        return x + ''
    }
  }
  if (texto && typeof texto === 'string') {
    if (parametros && Array.isArray(parametros)) {
      if (parametros.length > 0) {
        parametros.foreach(p => {
          texto = texto.replace(/{%[a-zA-Z0-9\-\_]*%}/i, _safeToString(p))
        })
        return texto
      }
      return texto
    } else if (parametros && typeof parametros === 'object' && parametros !== null) {
      Object.keys(parametros).filter((k) => {
        if (parametros[k]) { return true }
        return false
      })
        .map(k => texto = texto.replace(new RegExp('{%[ \t]*' + k + '[ \t]*%}', 'i'), parametros[k]))
    }
  }
  return texto
}

function isEmpty (obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) { return false }
  }
  return true
}

/**
 *  Recebe um Number e retorna uma String com um numero abreviado. K ~ Mi ~ Bi
 *  @numero Number
 *  @fator Number/String
 *  @sufixo String
 *  return String
*/
function formatarGrandesNumeros (numero) {
  // Eu não Faço ideia de como isso funciona.
  try {
    const si = [
      { value: 1, symbol: '' },
      // { value: 1E3, symbol: '' }, //100
      { value: 1E6, symbol: ' Mi' },
      { value: 1E9, symbol: 'Bi' },
      { value: 1E12, symbol: ' Tri' },
    ]
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
    let i
    for (i = si.length - 1; i > 0; i--) {
      if (numero >= si[i].value) {
        let x = (numero / si[i].value)
        return x.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + si[i].symbol
      }
    }

    return numero.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
  } catch (e) {
    console.error('MetodosGlobais.formatarGrandesNumeros recebeu valor diferente de number ou string ' + numero)
    return null
  }
}

function formataStringCallback (maxChar) {
  return function (value, index, values) {
    return value.length > maxChar ? value.substring(0, maxChar) + '...' : value
  }
}

function abreviarOrgaos (nome) {
  let texto = nome.split(' ')
  let retorno = ''
  texto.forEach(palavra => {
    if (palavra == 'SUBPREFEITURA') retorno += 'SUB. '
    else if (palavra.toUpperCase() === 'MUNICIPAL') retorno += ''
    else if (palavra.toUpperCase() === 'SECRETARIA') retorno += 'SEC. '
    else if (palavra.toUpperCase() === 'PROCURADORIA') retorno += 'PROC. '
    else if (palavra.toUpperCase() === 'CONTROLADORIA') retorno += 'CONTR. '
    else retorno += palavra + ' '
  })

  return retorno
}

function abreviarCargos (nome) {
  let texto = nome.split(' ')
  let retorno = ''
  texto.forEach(palavra => {
    if (palavra.toUpperCase() === 'ANALISTA') retorno += 'ANAL.ª '
    else if (palavra.toUpperCase() === 'ASSISTENTE') retorno += 'ASSIST. '
    else if (palavra.toUpperCase() === 'METROPOLITANO') retorno += 'METRO. '
    else if (palavra.toUpperCase() === 'FUDAMENTAL') retorno += 'FUND. '
    else if (palavra.toUpperCase() === 'PROFESSOR') retorno += 'PROF. '
    else if (palavra.toUpperCase() === 'POLITICAS') retorno += 'POLIT. '
    else if (palavra.toUpperCase() === 'PUBLICAS') retorno += 'PUBLI. '
    else retorno += palavra + ' '
  })

  return retorno
}

/**
 *  TODO : Refatorar
 *  Mudar Nome
 *  Metodo para usar em callbacks de tabelas ou graficos.
 *  recebe um numero, um sufixo positivo, um sufixo negativo, um valor para representar NaN's e um Booleano para definir se a representação sera em percentual ou numero real
 *  @return String
 */
function check (number, sup, sub, none, percentural = false) {
  if (typeof number === 'number') {
    if (number >= 0) {
      return (percentural ? formataPercentual(number) : number.toLocaleString('pt-BR')) + ' ' + sup
    } else if (number < 0) {
      return (percentural ? formataPercentual(number) : number.toLocaleString('pt-BR')) + ' ' + sub
    } else {
      return (percentural ? formataPercentual(number) : number.toLocaleString('pt-BR'))
    }
  }
  return none
}

/**
 * Cria um array de números inteiros no intervalo de início até o fim
 *
 * Ex.: range(1990,2001)
 * retorno: [1990,1991,1992,1993,1994,1995,1996,1997,1998,1999,2000,2001]
 *
 * @param {Integer} inicio range inicial
 * @param {Integer} fim range final
 * @return {Array} array com o range definido
 */
function range (inicio, fim) {
  return Array.from({ length: (fim - inicio + 1) }, (v, k) => k + inicio)
}

/**
 * Agrupa e soma objetos de uma array por múltiplas chaves
 * https://stackoverflow.com/questions/46794232/group-objects-by-multiple-properties-in-array-then-sum-up-their-values
 *
 * Ex.:
 *
 * var arr = [
 *  {shape: 'square', color: 'red', used: 1, instances: 1},
 *  {shape: 'square', color: 'red', used: 2, instances: 1},
 *  {shape: 'circle', color: 'blue', used: 0, instances: 0}]
 *
 *  multipleGroupAndSum(arr, ['shape', 'color'], ['used', 'instances']);
 *
 * Retorno: [{shape: 'square', color: 'red', used: 3, instances: 2},
 *           {shape: 'circle', color: 'blue', used: 0, instances: 0}]
 *
 * @param {Array} arr array com objetos a serem agrupados
 * @param {Array} groupKeys chaves a serem usadas para o agrupamento
 * @param {Array} sumKeys chaves a serem usadas para o somatório
 * @return {Array} array de objetos agrupados e somados
 */
function multipleGroupAndSum (arr, groupKeys, sumKeys) {
  return Object.values(
    arr.reduce((acc, curr) => {
      const group = groupKeys.map(k => curr[k]).join('-')
      acc[group] = acc[group] || Object.fromEntries(groupKeys.map(k => [k, curr[k]]).concat(sumKeys.map(k => [k, 0])))
      sumKeys.forEach(k => acc[group][k] += curr[k])
      return acc
    }, {})
  )
}

/**
 * Transforma um vetor plano de objetos em datasets para gráficos de linha simples
 *
 * Ex.: O exemplo abaixo irá gerar um grafico de linha com dois valores no eixo X (2020,2021)
 *      e para cada raca, será criado um dataset, usando-se o valor total como pontos do gráfico (eixo y)
 *      e passando-se um vetorCores (que pode ser obtido no CorUtils). Deve-se notar que para
 *      valores faltantes, o algorítimo preenche com valor 0 (zero).
 *
 * var arr = [
 *      {"ano": 2020, "raca": "PARDA", "total": 552  },
 *      {"ano": 2020, "raca": "PRETA", "total": 298  },
 *      {"ano": 2021, "raca": "PARDA", "total": 349  },
 *      {"ano": 2021, "raca": "PRETA", "total": 461  },
 *      {"ano": 2021, "raca": "AMARELA", "total": 18 }]
 *
 *  flatArrayToLineChartDatasets(arr, 'ano', 'raca', 'total', vetorCores)
 *
 * Retorno: {"labels": [2020,2021],
 *           "datasets": [{"data": [552,349],
 *                         "label": "PARDA",
 *                         "fill": false,
 *                         "spanGaps":true
 *                        },
 *                        {"data": [298,461],
 *                         "label": "PRETA",
 *                         "fill": false,
 *                         "spanGaps": true
 *                        },
 *                        {"data": [0,18],
 *                         "label": "AMARELA",
 *                         "fill": false,
 *                         "spanGaps": true
 *                        }]
 *            }
 *
 *  Ou seja, usou-se o ano como eixo X, raca como valor de cada dataset e total
 *  como  o valor que irá para cada um dos pontos do gráfico. Deve-se passar o
 *  vetor já ordenado de acordo com a chave desejada (no exemplo, o ano)
 *
 * @param {Array} flatDataset array plana com objetos a serem transformados em datasets
 * @param {String} eixoX nome do campo que identificará a chave dos valores do eixo X
 * @param {String} campoDataSet nome do campo que identificará a chave dos valores que virarão datasets
 * @param {String} campoValor nome do campo que identificará a chave dos valores que virarão pontos no gráfico
 * @return {Array} array de objetos no formato de datasets para gráficos de linha
 */
function flatArrayToLineChartDatasets (flatDataset, eixoX, campoDataSet, campoValor, vetorCores) {
  var chartData = { labels: [], datasets: [] }
  var datasetsTemp = {}

  flatDataset.forEach(element => {
    addEixoX(element[eixoX])
  })

  flatDataset.forEach(element => {
    if (typeof datasetsTemp[element[campoDataSet]] === 'undefined') {
      datasetsTemp[element[campoDataSet]] = getDataSet(element[campoDataSet], vetorCores.shift())
    }
    let posicao = chartData.labels.indexOf(element[eixoX])
    if (posicao != -1) { datasetsTemp[element[campoDataSet]].data[posicao] = element[campoValor] }
  })

  for (const [key, value] of Object.entries(datasetsTemp)) {
    chartData.datasets.push(value)
  }

  return chartData

  function getDataSet (nome, cor) {
    return {
      data: new Array(chartData.labels.length).fill(0),
      label: nome,
      backgroundColor: cor,
      borderColor: cor,
      fill: false,
      spanGaps: true,
    }
  }

  function addEixoX (element) {
    if (chartData.labels.indexOf(element) == -1) { chartData.labels.push(element) }
  }
}

/**
 *
 * @param {*} array
 * @param {*} string
 * @returns  array
 */
function filterByString (array, string) {
  return array.filter((obj) => {
    return Object.keys(obj).reduce((acc, curr) => {
      if (typeof obj[curr] === 'string') {
        return acc || obj[curr].toLowerCase().includes(string.trim().toLowerCase())
      } else if (typeof obj[curr] === 'number') {
        let a = _.find(SPMapaNomes, (e) => { return (e.id === obj[curr] && e.nome === string) && e.nome })
        if (a) return acc || a
        return acc || obj[curr] <= parseInt(string)
      } else {
        return acc
      }
    }, false)
  })
}

/**
 *
 * @param {*} array
 * @param {*} number
 * @returns array
 */
function filterByNumber (array, number) {
  let qtd = number.split('').length
  return array.filter((obj) => {
    return Object.keys(obj).reduce((acc, curr) => {
      if (typeof obj[curr] === 'number') {
        let aux = 0
        for (let i = 0; i < qtd; i++) {
          if (parseFloat(String(obj[curr]).charAt(i)) == parseInt(number.charAt(i))) aux++
        }
        if (aux == qtd) {
          return obj[curr]
        }
        return acc
      }
    }, false)
  })
}

/**
 *
 * @param {*} array
 * @param {*} param1
 * @param {*} atributo
 * @returns array
 */
function filterByRange (array, [inicial, final], atributo) {
  return array.filter((obj) => {
    return Object.keys(obj).reduce((acc, curr) => {
      return acc || (parseFloat(obj.perc_estoque) <= final && parseFloat(obj[atributo]) >= inicial)
    }, false)
  })
}

function filtraTermoBusca (termoBusca, dataset) {
  if (!termoBusca) {
    termoBusca = ''
  }
  if ((!Number.isNaN(parseInt(termoBusca))) && termoBusca !== '') {
    return filterByNumber(dataset, termoBusca)
  } else {
    return filterByString(dataset, termoBusca)
  }
}

/**
 *  Recebe um objeto e um atributo e valida se ele é undefined ou nulo,
 *  Se NÃO: retorna o valor do objeto[atributo].
 *  Se SIM: retorna o valor de negativeAnswer
 * @param {Object} element
 * @param {String} artribute
 * @param {*} defaultAnswer
 */
function isNullOrUndefined (element, attribute, negativeAnswer) {
  if (element) {
    return (attribute in element && element[attribute] === undefined) ? element[attribute] : negativeAnswer
  } else {
    return negativeAnswer
  }
}

function isTextoVazio(texto) {
  return (!texto || /^\s*$/.test(texto));
}
/**
 * Formata uma data do tipo Date em uma string no formato yyyy-MM-dd HH:mm:ss com o timezone no horário
 * Ex.:
 * 
 * Para uma data Date("05/29/2021 14:29:33")
 * 
 * Será retornada a String 2021-05-29 14:29:33
 * 
 * @param {Date} data 
 * @returns {String} no formato yyyy-MM-dd HH:mm:ss
 */
function formataDataHora(data) {
  if (Object.prototype.toString.call(data) === '[object Date]') {
    if (isNaN(data.getTime())) {
      return false
    } else {
      return `${data.toISOString().split("T")[0]} ${data.toLocaleTimeString()}`
    }
  } else {
    return false
  }
}

/**
 * 
 * Converte um Date em uma string local sem considerar o timezone. Ex.:
 * 
 * Para uma data Date("2021-11-03")
 * 
 * Será retornada a String 03/11/2021
 * 
 * @param {Date} data 
 * @returns {String} no formato dd/MM/yyyy desconsiderando o timezone (data exata)
 */
function formataDataParaStringDataLocal(data) {
    if (Object.prototype.toString.call(data) === '[object Date]') {
      if (isNaN(data.getTime())) {
        return false
      } else {
        return `${data.getUTCDate().toString().padStart(2, '0')}/${(data.getUTCMonth() + 1).toString().padStart(2, '0')}/${data.getUTCFullYear()}`
      }
    } else {
      return false
   }
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}